import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DmcQuotesService {

  private _dmcApiUrl = `${environment.dmc}/quotes`;

  constructor(
    private _http: HttpClient
  ) { }

  // Get all quotes
  getAllQuotes(pageNumber: any, pageSize: any, token: any, searchValue: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 10,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._dmcApiUrl}`, paginationSettings);
  }

  getAllQuotesWithFilters(pageNumber: any, pageSize: any, token: any, searchValue: any, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 10,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._dmcApiUrl}/filter`, paginationSettings);
  }

  // get all ltinerary for a lead
  getAllItinerarysForLead(id: any, pageNumber: any, pageSize: any, token: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20
    }
    return this._http.post<any>(`${environment.dmc}/quotesoflead/${id}`, paginationSettings);
  }

  // Add itinerary details
  addItineraryDetails(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/itinerarydetails`, formData);
  }

  // Add route craft data
  addRouteCraft(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/routecraft`, formData)
  }

  // Add Hotel pricing data
  addHotelPricing(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/accommodation`, formData)
  }

  // Add Hotel pricing data
  addAddOnTickets(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/tickets`, formData)
  }

  // Add inclusoins and exclusions data
  addInclusionsAndExclusions(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/inclusionandexclusion`, formData)
  }

  // Add Terms and conditions data
  addTermsAndConditions(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/termsandcondition`, formData)
  }

  // Add payment Terms and conditions data
  addPaymentTermsAndConditions(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/paymenttermsandcondition`, formData)
  }

  // Add Cancellation policy data
  addCancellaionPolicy(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/cancellationpolicy`, formData)
  }

  // Add Important info data
  addImportantInformation(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/importantinformation`, formData)
  }

  // Add notes data
  addnotes(formData: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/notes`, formData)
  }

  updateQuoteTemplateDetails(quoteId: any, formData: FormData): Observable<any> {
    return this._http.put<any>(`${environment.inventory}/dmcquotetemplates/${quoteId}`, formData);
  }

  // Get quote data
  getQuoteData(id: any): Observable<any> {
    return this._http.get<any>(`${this._dmcApiUrl}/quote/${id}`)
  }

  // Get quote in form of template design (HTML rendering)
  getQuoteTemplateHtml(quoteId: any): Observable<any> {
    return this._http.get<any>(`${environment.inventory}/dmcquotetemplate/${quoteId}`, { responseType: 'text' as 'json' })
  }

  // Save as default inventory itinerary
  saveAsInventoryItinerary(quoteId: any): Observable<any> {
    return this._http.post<any>(`${this._dmcApiUrl}/${quoteId}`, {});
  }

  selectRecommendedItinerary(type: any, itineraryDetails: any): Observable<any> {
    return this._http.post<any>(`${environment.dmc}/recommendedQuote`, itineraryDetails);
  }

  // Update quote itineray
  updateQuote(id: any, formData: any): Observable<any> {
    return this._http.put<any>(`${this._dmcApiUrl}/quote/${id}`, formData);
  }

  // Delte quote itinery
  deleteQuote(id: any): Observable<any> {
    return this._http.delete<any>(`${this._dmcApiUrl}/quote/${id}`);
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${this._dmcApiUrl}/updatequotes`, req);
  }
}
